import { defineStore } from "pinia";
import { api } from "@/configs";
import { apiUrls } from "@/constants";
import Swal from "sweetalert2";

export const useSupportContactStore = defineStore("supportContact", {
    state: () => ({
        supportContact: [],
    }),

    actions: {
        async fetchSupportContact() {
            try {
                const response = await api.get(apiUrls.supportContacts);
                this.supportContact = response.data?.data ?? [];
            } catch (error) {
                console.error("Error fetching support contacts:", error);
                this.supportContact = [];
            }
        },

        async addSupportContact(payload) {
            try {
                await api.post(apiUrls.supportContacts, payload, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                await this.fetchSupportContact();

                Swal.fire("Support Contact Added Successfully", "", "success");
                return true;
            } catch (error) {
                console.error(error);
                Swal.fire("Failed to add Support Contact", "", "error");
                return false;
            }
        },

        async updateSupportContact(supportContactId, payload) {
            try {
                const formData = new FormData();
                formData.append("_method", "PATCH");

                Object.keys(payload).forEach((key) => {
                    if (payload[key] !== null && payload[key] !== undefined) {
                        formData.append(key, payload[key]);
                    }
                });

                await api.post(
                    `${apiUrls.supportContacts}/${supportContactId}`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                await this.fetchSupportContact();

                Swal.fire("Support Contact Updated Successfully", "", "success");
                return true;
            } catch (error) {
                console.error("Error updating support contact:", error);
                Swal.fire("Failed to update support contact", "", "error");
                return false;
            }
        },

        async deleteSupportContact(supportContactId) {
            try {
                await api.delete(`${apiUrls.supportContacts}/${supportContactId}`);

                // Correct way to remove item from array
                this.supportContact = this.supportContact.filter(
                    (supportContact) => supportContact.id !== supportContactId
                );

                Swal.fire("Support Contact Deleted Successfully", "", "success");
                return true;
            } catch (error) {
                console.error(error);
                Swal.fire("Failed to delete Support Contact", "", "error");
                return false;
            }
        },

        async updateSupportContactStatus(id) {
            try {
                await api.patch(
                    `${apiUrls.supportContacts}/status/${id}`
                );

                // Optional: re-fetch or update locally
                await this.fetchSupportContact();

                Swal.fire("Status Updated Successfully", "", "success");
                return true;
            } catch (error) {
                console.error(error);
                Swal.fire("Failed to update status", "", "error");
                return false;
            }
        },
    }


});